import { render, staticRenderFns } from "./InsightsAudiences.vue?vue&type=template&id=2c7109cc&scoped=true"
import script from "./InsightsAudiences.vue?vue&type=script&lang=js"
export * from "./InsightsAudiences.vue?vue&type=script&lang=js"
import style0 from "./InsightsAudiences.vue?vue&type=style&index=0&id=2c7109cc&prod&lang=scss&scoped=true"
import style1 from "./InsightsAudiences.vue?vue&type=style&index=1&id=2c7109cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7109cc",
  null
  
)

export default component.exports